import {connect} from "react-redux";
import AddStrategyDialog from "~/components/AddStrategyDialog";

function mapStateToProps(state) {
    return {
        defaultStrategies: state.matchingStrategy.defaultStrategies,
    };
}

const mapDispatchToProps = {
    //
};

export default connect(mapStateToProps, mapDispatchToProps)(AddStrategyDialog);
